import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import HairStraightenerWrapper from "@components/layouts/hairstraightenerWrapper";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";
import colors from "@styles/variables/hairstraightenerVariables.module.scss";
export default function HairStraightenerHome(): ReactElement {
    return (
        <HairStraightenerWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor={colors.mainColor} />
                </div>
                <FormSection iconsFillColor={colors.mainColor} />
            </div>
        </HairStraightenerWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
